import apiClient from './apiClient';

const userService = {
  getAll: async (page = 1, limit = 20, filters = {}) => {
    const params = new URLSearchParams({
      page,
      limit,
      ...filters
    });
    const response = await apiClient.get(`/users?${params}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/users/${id}`);
    return response.data;
  },

  create: async (payload) => {
    const response = await apiClient.post('/users', payload);
    return response.data;
  },

  update: async (id, payload) => {
    const response = await apiClient.put(`/users/${id}`, payload);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/users/${id}`);
    return response.data;
  },

  updateProfile: async (payload) => {
    const response = await apiClient.put('/users/me', payload);
    return response.data;
  },

  changePassword: async (payload) => {
    const response = await apiClient.put('/users/me/change-password', payload);
    return response.data;
  },

  uploadProfilePhoto: async (file) => {
    const formData = new FormData();
    formData.append('profilePhoto', file);
    const response = await apiClient.post('/users/me/profile-photo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  }
};

export default userService;
